import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';

import { loadAccountManagerReCaptchaScript, hideAccountManagerReCaptchaBadge } from '../utils/page';
import useActivePage from '../../shared/custom-hooks/active-page';

const MetaData = ({ children }) => {
  const { title, name } = useActivePage();
  hideAccountManagerReCaptchaBadge(name);

  useEffect(() => {
    loadAccountManagerReCaptchaScript(name);
  }, [name]);

  return (
    <>
      <Helmet>
        <title>{title} | Formplus</title>
      </Helmet>

      {children}
    </>
  );
};

export default MetaData;